<template>
    <div>
        <outgoing-number-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addOutgoingNumber">
                    <i class="far fa-file"/>
                </button>
            </template>
        </outgoing-number-table>
        <dialog-form-wrapper/>
    </div>
</template>

<script>
  import OutgoingNumberTable from '../../components/outgoing-number/table';
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';

  export default {
    components: {
      OutgoingNumberTable,
      DialogFormWrapper,
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @event show-add-outgoing-number-dialog
       */
      addOutgoingNumber() {
        eventBus.$emit('show-add-outgoing-number-dialog', this.createUrl);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },
    },

    created() {
      eventBus.$on('refresh-outgoing-number-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-outgoing-number-table', this.refresh);
    }
  }
</script>
